import React, { useContext, useEffect } from 'react';

import { os } from '@mirinae/js-utils/utils/userAgent';
import { UserContext, authAPI } from '@mirinae/react-auth';
import { HeaderComponent } from '@mirinae/react-gnb';

import { lessonsPaths, explorerPaths, membersPaths, authPaths, wikinaePaths } from '@mirinae/shared/defines/paths';
// import { Event } from '@mirinae/apis/GoogleAnalytics';
import { getUserType } from '@mirinae/shared/defines/datas';
import { useGlobalContext } from '@mirinae/lessons/modules/contexts/global';
import GTM from '@mirinae/shared/apis/GoogleAnalytics';
import Localization, { langsSelectList } from '@mirinae/shared/il8n';
import { useAppVersionStore } from '@mirinae/stores/appVersion';

const HeaderContainer = ({mode}) => {
    // const [, setCookies] = useCookies([]);
    authAPI.setHistory(window.history);
    // const isApp = useAppVersionStore(state => state.isApp);
    const { isApp, appVersion, isProEnabledVersion } = useAppVersionStore();


    // remove on Lesson Player page
    const [userContext] = useContext(UserContext);
    const global = useGlobalContext(appVersion, isProEnabledVersion);

    const { user } = userContext;

    // const guestMode = userContext.user.name === undefined || userContext.user.name === '' || userContext.user.role === 'guest';

    // const movePage = (path) => {
    //     if (history.location.pathname !== path) {
    //         // console.log(history.location.pathname, path);
    //         // history.push(path);
    //     }
    // };
    const handleClickPrefs = (newPrefs) => {
        const updatedPrefs = ({ ...global.prefs, ...newPrefs });
        authAPI.updatePrefs(updatedPrefs).then(() => {
            global.update({ ...updatedPrefs });
            if (newPrefs.language) {
                Localization.setLanguage(newPrefs.language);
                document.querySelector('html').setAttribute('lang', newPrefs.language);
                GTM.userAction('lang-select', { language: newPrefs.language }, 'members');
                window.location.reload();
            }
        });
    };

    const handlelogout = () => {
        authAPI.logout().then(() => {
            // force a page-reload to induce guest-user reset
            window.location.href = lessonsPaths.home;
        });
    };

    useEffect(() => {
        // set language value
        if (userContext.user.preferences) {
            const tempGlobalPrefs = global.prefs || {};
            const prefs = ({ ...tempGlobalPrefs, ...userContext.user.preferences });
            if (prefs.language !== Localization.getLanguage()) {
                Localization.setLanguage(prefs.language);
                GTM.userAction('lang-select', { language: prefs.language }, 'members');
            }
            if (prefs.language !== document.querySelector('html').getAttribute('lang')) {
                document.querySelector('html').setAttribute('lang', prefs.language);
            }
        }
    }, [userContext.user && userContext.user.preferences]);

    // useEffect(() => {
    //     // cookies[1]('vl', 'true', { path: explorerHost, maxAge: 10 * 365 * 24 * 60 * 60 }); // visited lessons
    //     // setCookies('vl', 'true', { path: '/', domain: `.${cookieDomain}`, maxAge: 10 * 365 * 24 * 60 * 60 });
    //     handleClose();
    //     document.body.addEventListener('click', handleClose, false);

    //     setTimeout(() => setMounted(true), 400); // transition time

    //     return () => {
    //         document.body.removeEventListener('click', handleClose);
    //     };
    // }, []);

    // useEffect(() => {
    //     setDisplayLayer(false);
    // }, [location.pathname, guestMode]);

    // const gnbMenus = [
    //     { id: 'analyze', name: 'analyzer', link: explorerPaths.home, active: false, disabled: false },
    //     { id: 'lessons', name: 'lessons', link: lessonsPaths.home, active: false, disabled: false },
    //     { id: 'library', name: 'library', link: explorerPaths.library, active: false, disabled: false },
    //     { id: 'pro', name: 'pro', link: membersPaths.plan, active: location.pathname === membersPaths.plan, disabled: false },
    //     { id: 'profile', name: 'profile', link: membersPaths.profile, active: [membersPaths.profile, membersPaths.accountSetting, membersPaths.subscription].indexOf(location.pathname) !== -1, disabled: false },
    // ];

    const gnbLinks = {
        home: '/',
        lessons: lessonsPaths.home,
        library: explorerPaths.reference,
        wikinae: wikinaePaths.home,
        pro: membersPaths.home,
        profile: membersPaths.profile,
        login: `${authPaths.login}?redirect=${lessonsPaths.home}`,
        signup: `${authPaths.signup}?redirect=${lessonsPaths.home}`,
        help: explorerPaths.help,
    };

    // hide if in app or Lesson Player page
    return isApp || location.pathname.indexOf(lessonsPaths.player) !== -1 || (!os.isOthers && location.pathname.indexOf(lessonsPaths.onelesson) !== -1) ? null : (
        <HeaderComponent
            links={gnbLinks}
            isApp={isApp} mode={mode}
            user={userContext.user} userType={getUserType(userContext.user)}
            langsList={langsSelectList}
            onLogout={handlelogout} prefs={user.preferences}
            onClickPrefs={handleClickPrefs}
            localization={Localization}
        />
    );
};

export default HeaderContainer;